import React from "react";
import { useSelector } from "react-redux";
import Media from "react-media";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../../store/validation/is-Empty";

export const SuperAdminHASHomeScreen = (props) => {
  const editAction = useSelector((state) => {
    return !isEmpty(
      state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData
    )
      ? state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData
      : false;
  });
  return (
    <React.Fragment>
      <div className="col-12 p-0">
        <h4 className="font_18_b c_black mt-4 mb-3">
          Key Points about you that Customer Must Be Aware Of:
        </h4>
        <div
          className="mobile-health-san-mb-180px"
          style={{ height: "52vh", maxWidth: 500 }}
        >
          <p className="f12-400">
            Wash your hands thoroughly before beginning your daily chores,
            handling the food, after every break, handling raw foods or waste,
            etc. Discourage the use of sanitizers in the kitchen areas and wash
            hands with automatic soap dispensers.
          </p>
          <br />
          <p className="f12-400">
            Avoid unnecessary contact with the food. Do not allow your kitchen
            staff to handle it with bare hands. Ask them to wear single-use
            gloves and throw them away after each use.
          </p>
          <br />
          <p className="f12-400">
            Promote good hygiene by minimizing personal contact and tampering or
            breathing over food. Do not cough, sneeze, or spit near the food
            areas and avoid coming to the restaurant, if unwell.
          </p>
          <br />
          <p className="f12-400">
            Make it a point to disinfect all the equipment, utensils, and clean
            the surfaces thoroughly.
          </p>
          <br />
          <p className="f12-400">
            Follow all the specific food safety instructions set by the
            supervisors and health professionals and maintain a daily personal
            hygiene checklist.
          </p>
        </div>
        <div className="onboarding-map-setup-screen-autodetect-button ">
          <Media query="(min-width: 992px)">
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              link={
                editAction ? "/admin_edit_pointofsale" : "/addvendorpointofsale"
              }
            />
          </Media>
          <Media query="(max-width: 991px)">
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              buttonType="button"
              onClick={props.handleFormHide}
            />
          </Media>
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Next"
            buttonType="button"
            onClick={props.onClickHome}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
